import { render } from "./LockIcon.vue?vue&type=template&id=5b1b3cd3"
import script from "./LockIcon.vue?vue&type=script&lang=js"
export * from "./LockIcon.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__